(() => {
 const root = document.querySelector('[data-bp-concepts]');
 if (!root) return;
 const choices = [...root.querySelectorAll('[data-concept-choice]')];
 const summary = root.querySelector('[data-concept-summary]');
 const count = root.querySelector('[data-concept-count]');
 const links = [...root.querySelectorAll('[data-interest]')];
 const optin = root.querySelector('[data-launch-optin]');
 const preference = root.querySelector('[data-launch-preference]');
 function recordPreference() {
  if (preference) preference.value = optin && optin.checked ? 'Yes — selected designs launch updates and offer' : 'No — feedback only, launch email not requested';
 }
 if (optin) optin.addEventListener('change', recordPreference);
 recordPreference();
 function sync() {
  const selected = choices.filter(input => input.checked);
  summary.value = selected.map(input => input.value).join(', ');
  count.textContent = selected.length ? `${selected.length} design${selected.length === 1 ? '' : 's'} selected. You can choose more than one.` : 'Choose your favorites above.';
  if (choices[0]) choices[0].setCustomValidity(selected.length ? '' : 'Choose at least one design.');
  links.forEach(link => { const selected = choices.some(input => input.value === link.dataset.interest && input.checked); link.textContent = selected ? 'Selected — view your choices →' : 'I’m interested →'; });
 }
 choices.forEach(input => input.addEventListener('change', sync));
 links.forEach(link => link.addEventListener('click', event => {
  event.preventDefault();
  const choice = choices.find(input => input.value === link.dataset.interest);
  if (!choice) return;
  choice.checked = true;
  sync();
  const success = root.querySelector('.bp-concept-success');
  if (success) success.hidden = true;
  const url = new URL(window.location.href);
  url.searchParams.delete('contact_posted');
  url.hash = 'BPConceptInterest';
  history.replaceState(null, '', url);
  root.querySelector('#BPConceptInterest').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  root.querySelector('#BPInterestTitle').focus({ preventScroll: true });
 }));
 sync();
})();
